import { useTranslation } from "react-i18next";
import Bloc0BlockSection from "./blocks/Bloc0BlockSection";
import Bloc1BlockSection from "./blocks/Bloc1BlockSection";
import Bloc2BlockSection from "./blocks/Bloc2BlockSection";
import Bloc3BlockSection from "./blocks/Bloc3BlockSection";
import Bloc4BlockSection from "./blocks/Bloc4BlockSection";
import Bloc5BlockSection from "./blocks/Bloc5BlockSection";
import Bloc6BlockSection from "./blocks/Bloc6BlockSection";
import Bloc7BlockSection from "./blocks/Bloc7BlockSection";

export default function DashboardBlockSection({
  id,
  title,
  description,
  fields = [],
  mode = "placeholder",
  data = null,
  charts = null,
  loading = false,
  error = null,
}) {
  const { t } = useTranslation();
  const itemsByField = Object.fromEntries(
    (data?.items || []).map((item) => [item.field, item])
  );

  if (mode === "live") {
    if (id === "bloc2") {
      return (
        <Bloc2BlockSection
          id={id}
          title={title}
          description={description}
          loading={loading}
          error={error}
          itemsByField={itemsByField}
        />
      );
    }

    if (id === "bloc3") {
      return (
        <Bloc3BlockSection
          id={id}
          title={title}
          description={description}
          loading={loading}
          error={error}
          itemsByField={itemsByField}
        />
      );
    }

    if (id === "bloc0") {
      return (
        <Bloc0BlockSection
          id={id}
          title={title}
          description={description}
          charts={charts}
          loading={loading}
          error={error}
          itemsByField={itemsByField}
        />
      );
    }

    if (id === "bloc4") {
      return (
        <Bloc4BlockSection
          id={id}
          title={title}
          description={description}
          loading={loading}
          error={error}
          itemsByField={itemsByField}
        />
      );
    }

    if (id === "bloc5") {
      return (
        <Bloc5BlockSection
          id={id}
          title={title}
          description={description}
          loading={loading}
          error={error}
          itemsByField={itemsByField}
        />
      );
    }

    if (id === "bloc6") {
      return (
        <Bloc6BlockSection
          id={id}
          title={title}
          description={description}
          loading={loading}
          error={error}
          itemsByField={itemsByField}
        />
      );
    }

    if (id === "bloc7") {
      return (
        <Bloc7BlockSection
          id={id}
          title={title}
          description={description}
          loading={loading}
          error={error}
          itemsByField={itemsByField}
        />
      );
    }

    return (
      <Bloc1BlockSection
        id={id}
        title={title}
        description={description}
        charts={charts}
        loading={loading}
        error={error}
        itemsByField={itemsByField}
      />
    );
  }

  return (
    <section
      id={id}
      className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
          <p className="text-sm text-slate-600 mt-1">{description}</p>
        </div>

        <div className="text-xs rounded-full bg-slate-100 text-slate-700 px-3 py-1 whitespace-nowrap">
          Placeholder
        </div>
      </div>

      <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-3 mb-4">
        <p className="text-sm text-slate-700">
          {t(
            "dashboard.placeholder.description",
            "Aquesta secció queda preparada per mostrar estadístiques del bloc en la segona fase, reutilitzant els filtres globals del dashboard."
          )}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {fields.map((field) => (
          <div
            key={field.key}
            className="rounded-xl border border-slate-200 bg-slate-50/70 p-4"
          >
            <div className="text-sm font-medium text-slate-900">
              {field.label}
            </div>
            <div className="text-xs text-slate-500 mt-1 uppercase tracking-wide">
              {field.kind}
            </div>
            <div className="text-sm text-slate-600 mt-3">
              {t(
                "dashboard.placeholder.pendingStats",
                "Estadístiques pendents d’integrar."
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
